const __WEBPACK_NAMESPACE_OBJECT__ = require("eth-rpc-errors");